module.exports = __webpack_public_path__ + "static/media/8OLA3.c33bef73.jpg";